/**
 * Resolución de playback Mux para /ar/invitacion (conversión VIP).
 *
 * Prioridad:
 * 1. layout.mux_playback_id (override por link desde admin)
 * 2. ?playback= (solo testing manual)
 * 3. VITE_AR_INVITACION_VIP_PLAYBACK_ID (default de producción)
 */

import { getArInvitacionDefaultVipPlaybackId } from "@/config/telegramGroupsVideo";

const MUX_ID_MIN_LEN = 10;
const PLACEHOLDER_RE = /your-|tu-|example|xxx/i;

export type ArInvitacionLayoutPlayback = {
  mux_playback_id?: string;
  playback_id?: string;
};

function sanitizeMuxPlaybackId(raw: string | undefined | null): string {
  const trimmed = typeof raw === "string" ? raw.trim() : "";
  if (trimmed.length < MUX_ID_MIN_LEN) return "";
  if (PLACEHOLDER_RE.test(trimmed)) return "";
  return trimmed;
}

export function resolveArInvitacionPlaybackFromLayout(
  layout?: ArInvitacionLayoutPlayback | null,
): string {
  if (!layout) return "";
  return (
    sanitizeMuxPlaybackId(layout.mux_playback_id) ||
    sanitizeMuxPlaybackId(layout.playback_id) ||
    ""
  );
}

export function resolveArInvitacionPlaybackFromQuery(
  searchParams: URLSearchParams,
): string {
  return sanitizeMuxPlaybackId(searchParams.get("playback"));
}

export type ArInvitacionPlaybackSources = {
  layout?: ArInvitacionLayoutPlayback | null;
  searchParams?: URLSearchParams;
};

/** Playback efectivo: override admin → query test → env VIP default. */
export function resolveArInvitacionPlaybackId(sources: ArInvitacionPlaybackSources): string {
  const fromLayout = resolveArInvitacionPlaybackFromLayout(sources.layout);
  if (fromLayout) return fromLayout;

  if (sources.searchParams) {
    const fromQuery = resolveArInvitacionPlaybackFromQuery(sources.searchParams);
    if (fromQuery) return fromQuery;
  }

  return getArInvitacionDefaultVipPlaybackId();
}

/** Formato precio ARS para CTA y modal (ej. $49.999/mes). */
export function formatArInvitacionVipPrice(priceArs: number): string {
  return `$${priceArs.toLocaleString("es-AR")}/mes`;
}